import { Button } from "@cmsgov/ds-medicare-gov";
import React, { useContext } from "react";
import {
  AnalyticsActionType,
  Ga4Event,
  Ga4EventType,
  TealiumEventProps,
} from "../app/contexts/Analytics/types";
import { AppContext } from "../app/store";
import { useTranslate } from "../helpers";

interface PrintButtonProps {
  tealiumProps?: TealiumEventProps;
  onClick?: () => void;
  className?: string;
}

export const printPage = (): void => {
  // For some reason, window.print is not working in Safari even though it's a supported function
  if (!document.execCommand("print", false, undefined)) {
    window.print();
  }
};

const PrintButton: React.FunctionComponent<PrintButtonProps> = ({
  children,
  tealiumProps,
  onClick,
  className,
  ...props
}) => {
  const t = useTranslate();
  const { dispatch } = useContext(AppContext);

  return (
    <Button
      variation="ghost"
      onClick={
        onClick ||
        ((): void => {
          if (tealiumProps) {
            dispatch({
              type: AnalyticsActionType.SEND_TEALIUM_EVENT,
              settings: tealiumProps,
            });
          }
          dispatch({
            type: AnalyticsActionType.SEND_GA4_EVENT,
            settings: {
              event_name: Ga4Event.PRINT,
              event_type: Ga4EventType.UI_INTERACTION,
            },
          });

          printPage();
        })
      }
      className={`PrintButton mct-hide-print ${className}`}
      {...props}
    >
      <span className="fa fa-print fa-lg" />
      <div>{children || t("print")}</div>
    </Button>
  );
};

export default PrintButton;
